import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  getDepartmentPositionDetailFailed,
  getDepartmentPositionDetailStart,
  getDepartmentPositionDetailSuccess,
} from "../redux/getDepartmentPositionDetail";
import { getDepartmentPositionDetailApi } from "core/http/service/recruitment";

import { formInputRecruitmentSelector } from "../redux/selector";
import { formRecruitmentUpdate } from "../redux/formInput";

function* getDepartmentPositionDetailWork() {
  const { rcmPositionCode } = yield select(formInputRecruitmentSelector);
  try {
    const res = yield call(getDepartmentPositionDetailApi, rcmPositionCode);
    yield put({
      type: getDepartmentPositionDetailSuccess.type,
    });

    yield put({
      type: formRecruitmentUpdate.type,
      payload: {
        jobDescription: res?.jobDescription || "",
      },
    });
  } catch (error) {
    yield put({
      type: getDepartmentPositionDetailFailed.type,
    });
  }
}

function* watchGetDepartmentPositionDetail() {
  yield takeLatest(
    getDepartmentPositionDetailStart.type,
    getDepartmentPositionDetailWork
  );
}

export default function* getDepartmentPositionDetailSaga() {
  yield all([watchGetDepartmentPositionDetail()]);
}
